<template>
  <div id="app" v-if="verified">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        verified: false,
      }
    },
    created() {
      // 获取本地储存的openid
      const userInfo = store.get('userInfo');

      if(userInfo && userInfo.user_token) {

        // 如果有则正常获取用户信息刷新
        this.$root.post('/getUserInfo', {
          user_token: store.get('userInfo').user_token
        }).then(data => {
          console.log("userinfo")
          console.log(data)
          // 有数据则更新localStorage和Vuex中的用户信息
          store.set('userInfo', data);
          this.$store.commit('setUserInfo', data);
          // 开启固定id调试
          if(userInfo.user_id==10032||userInfo.user_id==10036){

           let vConsole = new VConsole();
          }
          // 做用户跳转判断
          if(this.$route.path == '/patient/binding' && this.$route.query.scan) {
            this.$root.userRedirect(this.$store.state.userInfo, this.$route.fullPath, 'scan');
          }else if(this.$route.path == '/doctor/baseinfo' && this.$route.query.invite_id) {
            this.$root.userRedirect(this.$store.state.userInfo, this.$route.fullPath, 'invited');
          }else {
            this.$root.userRedirect(this.$store.state.userInfo, this.$route.fullPath);
          }
          // 显示页面
          this.verified = true;
        })
      }else {
        if(window.location.host == 'localhost:8080' || window.location.host == 'localhost:3000' || window.location.host == '192.168.198.10:3000') {
          alert("本地开发");
          // 本地开发


          const userInfo = {
            user_id: 10032,
            role: 1,
            avatar: 'http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJuhCLA9J2tJVvjoyibpC1ECdRTBP8wSqqNcic3I1icF4cDqxaAwulVAQo7nJYpWlqzMywicXcoyXGgYg/132',
            username: '写死的数据',
            gender: null,
            wechat_subscribe: 1,
            token: 'JsWPCvGqaZ7jShqMCoklwzVd9FKpoLm584XCoYtSjoLLn9LUBciNpnHG6VbZNVElCahO6PfPzlau/xyJKfgzbA==',
            user_token: 'JsWPCvGqaZ7jShqMCoklwzVd9FKpoLm584XCoYtSjoLLn9LUBciNpnHG6VbZNVElCahO6PfPzlau/xyJKfgzbA==', //医生openid
            // user_token: 'N0xjMnFlRlFVbnhlT2gxYlFxbE1zZjhuYTloVFRybU5Zb3RqNktYaDNOVT0=', //患者openid
            status: 1,
            doc_status: 4,
            type:1
          }
/*
          const userInfo = {
            user_id: 10036,
            role: 2,
            avatar: 'http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJuhCLA9J2tJVvjoyibpC1ECdRTBP8wSqqNcic3I1icF4cDqxaAwulVAQo7nJYpWlqzMywicXcoyXGgYg/132',
            username: '写死的数据',
            gender: null,
            wechat_subscribe: 1,
            token: 'd4kU3U8SIVmE3Ka8uW6TRVf6Ctr7kJuhM+Dq4LXRWBA=@icfc.cn.rongnav.com;icfc.cn.rongcfg.com',
            user_token: 'd4kU3U8SIVmE3Ka8uW6TRVf6Ctr7kJuhM+Dq4LXRWBA=@icfc.cn.rongnav.com;icfc.cn.rongcfg.com', //医生openid
            // user_token: 'N0xjMnFlRlFVbnhlT2gxYlFxbE1zZjhuYTloVFRybU5Zb3RqNktYaDNOVT0=', //患者openid
            status: 1,
            doc_status: 4,
          }
*/
          store.set('userInfo', userInfo);
          this.$store.commit('setUserInfo', userInfo);
          console.log(userInfo)
          if(this.$route.path == '/patient/binding' && this.$route.query.scan) {
            this.$root.userRedirect(this.$store.state.userInfo, 'scan');
          }else {
            this.$root.userRedirect(this.$store.state.userInfo);
          }
          this.verified = true;
        }else {
        // 如果没有本地信息则根据url参数中是否带有code判断
        let code = this.getQueryVariable('code')
        if(code) {
          // url中有code参数则利用code获取用户信息
          this.$root.post('/getUserByCode', {
            code: code
          }).then(data => {
            // 有数据则更新localStorage和Vuex中的用户信息
            store.set('userInfo', data);
            this.$store.commit('setUserInfo', data);
            // 还原正常的url
            const currentUrl = window.location.protocol + '//' + window.location.host + '/#' + this.$route.fullPath
            console.log('当前vue的fullpath为' + this.$route.fullPath)
            console.log(currentUrl)
            window.history.pushState({}, 0, currentUrl);
            // if(this.$store.state.userInfo.user_id == 203) {
            //   let vConsole = new VConsole();
            // }
            // 做用户跳转判断
            if(this.$route.path == '/patient/binding' && this.$route.query.scan) {
              this.$root.userRedirect(this.$store.state.userInfo, this.$route.fullPath, 'scan');
            }else if(this.$route.path == '/doctor/baseinfo' && this.$route.query.invite_id) {
              this.$root.userRedirect(this.$store.state.userInfo, this.$route.fullPath, 'invited');
            }else {
              this.$root.userRedirect(this.$store.state.userInfo, this.$route.fullPath);
            }
            // 显示页面
            this.verified = true;
          })
        }else {
          // url中无code并且没有本地信息则调起授权
          this.$root.post('/getOAuth', {
            state: window.location.href
          }, false).then(data => {
            // 跳转授权
            window.location.href = data;
          })
        }
        }


      }


      // 更新用户数据
      // this.$root.post('/getUserInfo').then(data => {
      //   // console.log(data);
      //   if(data.status == 1) {
      //     // 有数据则更新localStorage和Vuex中的用户信息
      //     store.set('userInfo', data);
      //     this.$store.commit('setUserInfo', data);
      //     if(this.$route.path == '/patient/binding' && this.$route.query.scan) {
      //       this.$root.userRedirect(this.$store.state.userInfo, 'scan');
      //     }else {
      //       this.$root.userRedirect(this.$store.state.userInfo);
      //     }
      //     // 显示页面
      //     this.verified = true;
      //   }else {
      //     // 无数据则调起授权
      //     this.$root.post('/getOAuth', {
      //       state: window.location.href
      //     }, false).then(data => {
      //       // 跳转授权
      //       window.location.href = data;
      //     })

      //     // 本地开发
      //     const userInfo = {
      //       user_id: 2,
      //       role: 2,
      //       avatar: 'http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJuhCLA9J2tJVvjoyibpC1ECdRTBP8wSqqNcic3I1icF4cDqxaAwulVAQo7nJYpWlqzMywicXcoyXGgYg/132',
      //       username: null,
      //       gender: null,
      //       wechat_subscribe: 1,
      //       token: null,
      //       // openid: 'bUxMZ3hvSWxSMmlaQzFRTWZqUUVIczBFdm5uYmVoTzljSiszeG9SY3hyMD0=', //医生openid
      //       openid: 'N0xjMnFlRlFVbnhlT2gxYlFxbE1zZjhuYTloVFRybU5Zb3RqNktYaDNOVT0=', //患者openid
      //       status: null,
      //     }
      //     store.set('userInfo', userInfo);
      //     this.$store.commit('setUserInfo', userInfo);
      //     if(this.$route.path == '/patient/binding' && this.$route.query.scan) {
      //       this.$root.userRedirect(this.$store.state.userInfo, 'scan');
      //     }else {
      //       this.$root.userRedirect(this.$store.state.userInfo);
      //     }
      //     this.verified = true;
      //   }
      // })
    },
    methods: {
      // 获取url中携带的code参数
      getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
          var pair = vars[i].split("=");
          if(pair[0] == variable){return pair[1];}
        }
        return(false);
      }
    }
  }
</script>

<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
}
html{
  height: 100%;
}
html, body{
  min-height: 100%;
  background: #FFF;
}
body,h1,h2,h3,h4,h5,h6,dl,dt,dd,ul,ol,li,th,td,p,blockquote,pre,form,fieldset,legend,input,button,textarea,article,aside,footer,header,hgroup,nav,section,menu {
  margin: 0;
  padding: 0;
  -webkit-text-size-adjust: 100%;
  box-sizing: border-box;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
em,i {
  font-style: normal;
}
li {
  list-style: none;
}
img {
  border: 0;
}
input,img {
  vertical-align: middle;
}
input,textarea{
  &::-webkit-input-placeholder{
    color: #999;
  }
  border: 0;
  box-sizing: border-box;
  -webkit-appearance: none;
}
article,aside,footer,header,hgroup,nav,section,menu {
  display: block;
}
*{
  box-sizing: border-box;
}
body.full-height{
  height: 100%;
  #app{
    height: 100%;
    min-height: auto;
    .consulting-wrapper{
      height: 100%;
    }
  }
}
.list-loading{
  padding-top: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.empty-data{
  padding-top: 220px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #CCC;
  text-align: center;
  flex-direction: column;
  svg{
    font-size: 72px;
  }
  p{
    margin-top: 12px;
    font-size: 15px;
    line-height: 15px;
  }
}
.data-loading{
  padding: 16px 0 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.data-finish{
  padding: 16px 0 24px;
  text-align: center;
  font-size: 12px;
  line-height: 12px;
  color: #999;
}
.error-page{
  width: 100%;
  min-height: 100vh;
  padding-top: 120px;
  text-align: center;
  svg{
    font-size: 80px;
    color: @error;
  }
  p{
    margin-top: 20px;
    font-size: 18px;
    font-weight: bold;
    color: #999;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue